import { inject } from '@angular/core';
import { environment } from '@orderna/admin-panel/src/environments/environment';
import { Socket, io } from 'socket.io-client';
import { LocalStorageService } from '../../shared/services/local-storage.service';

export abstract class BaseGatewayService {
  protected socket?: Socket;
  protected localStorageService = inject(LocalStorageService);

  protected abstract namespace: string;

  connect() {
    if (this.socket?.connected) this.socket.disconnect();

    this.socket = io(`${environment.apiBaseUrl}/${this.namespace}`, {
      transports: ['websocket'],
      auth: { token: this.localStorageService.getAccessToken() },
    });

    this.initSocketListeners();
  }

  disconnect() {
    if (this.socket?.connected) {
      this.socket.disconnect();
    }
  }

  refreshConnection() {
    if (!this.socket) return;

    const newToken = this.localStorageService.getAccessToken();

    // only reconnect if currently connected
    if (this.socket.connected) {
      this.socket.disconnect();
      this.socket.auth = { token: newToken };
      this.socket.connect();
    } else {
      // if socket is disconnected, just update the token for when it reconnects later
      this.socket.auth = { token: newToken };
    }
  }

  private initSocketListeners() {
    if (!this.socket) return;

    const namespace = this.namespace;

    this.socket.on('connect', () =>
      console.debug(`[${namespace}] Connected:`, this.socket?.id)
    );
    this.socket.on('connect_error', (err) =>
      console.error(`[${namespace}] Connect error:`, err)
    );
    this.socket.on('disconnect', () =>
      console.warn(`[${namespace}] Disconnected`)
    );
  }
}
